module.exports = __webpack_public_path__ + "img/939716.2258a0b0.png";